module.exports = __webpack_public_path__ + "static/media/Menu.2f9794be.svg";